/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Checkbox, FormControlLabel, Grid, Stack, Typography, Chip, CircularProgress, Box } from '@mui/material';
import { LanguageContext } from '../../../../../../../libs/Context';
// import { roleCondition } from '../../../../../../../libs/HelperContent';
// import { useSelector } from 'react-redux';
import useFeedApproval from '../../CustomHooks/useFeedApproval';

interface Department {
	_id: string;
	name: string;
	description?: string;
}

const SelectRelations = (props) =>
{
	const { updateReltns, setUpdateReltns, relationsRef, departmentsRef, createFeedAs, userData } = props;
	const { language } = useContext(LanguageContext);
	// const userData = useSelector((state:any) => state.mysession.session);

	const [ departments, setDepartments ] = useState<Department[]>(departmentsRef?.current || []);
	// const [ selectedDepartments, setSelectedDepartments ] = useState<string[]>([]);
	const [ isLoading, setIsLoading ] = useState<boolean>(false);
	const { isFeedsAdmin } = useFeedApproval();

	useEffect(() =>
	{
		if (departmentsRef?.current && departmentsRef.current.length > 0)
		{
			setDepartments(departmentsRef.current);
			setIsLoading(false);
		}
		else
		{
			setIsLoading(false);
		}
	}, [ departmentsRef?.current ]);

	// useEffect(() =>
	// {
	// 	if (updateReltns && updateReltns.length > 0)
	// 	{
	// 		const internalEmployeesRelation = updateReltns.find((reltn) => reltn?.relation === 'company internal employees');

	// 		if (internalEmployeesRelation && internalEmployeesRelation.selectedDepartments)
	// 		{
	// 			setSelectedDepartments(internalEmployeesRelation.selectedDepartments);
	// 		}
	// 	}
	// }, [ updateReltns ]);

	const handleReltns = (reltn) =>
	{
		if (reltn === 'All')
		{
			// const newSelectedRelation = [];

			setUpdateReltns(updateReltns?.length >= relationsRef?.current?.length ? [] : [ ...(relationsRef?.current ?? []) ]);
		}
		else
		{
			const isInternalEmployees = reltn?.relation === 'company internal employees';
			const findExist = updateReltns?.some((reltns) => reltns?.relationId === reltn?.relationId);

			if (isInternalEmployees)
			{
				// If selecting internal employees, clear all departments
				if (!findExist)
				{
					// Remove all department strings and keep only relation objects
					const relationsWithoutDepartments = updateReltns.filter((data) => typeof data !== 'string');

					setUpdateReltns([ ...relationsWithoutDepartments, reltn ]);
				}
				else
				{
					setUpdateReltns(updateReltns?.filter((data) => data?.relationId !== reltn?.relationId));
				}
			}
			else
			{
				setUpdateReltns(findExist
					? updateReltns?.filter((data) => data?.relationId !== reltn?.relationId)
					: [ ...updateReltns, reltn ]
				);
			}
		}
	};

	const handleDepartmentClick = (deptName: string) =>
	{
		let newSelectedDepts = [ ...updateReltns ];

		// Handle department selection/deselection
		if (updateReltns.includes(`${userData?.companyId}-${deptName}`))
		{
			// removing dept from updateReltns
			newSelectedDepts = updateReltns.filter((item) => item !== `${userData?.companyId}-${deptName}`);
		}
		else
		{
			newSelectedDepts = newSelectedDepts.filter((r) => r?.relation !== 'company internal employees');
			newSelectedDepts.push(`${userData?.companyId}-${deptName}`);
		}

		setUpdateReltns(newSelectedDepts);
	};

	console.log('updateReltns', updateReltns);

	const isDepartmentSelected = (deptName: string) =>
	{
		return updateReltns.includes(`${userData?.companyId}-${deptName}`);
	};

	const isInternalEmployeesSelected = useMemo(() =>
	{
		return updateReltns?.some((dataD) => dataD?.relationId === relationsRef?.current?.find((r) => r?.relation === 'company internal employees')?.relationId);
	}, [ updateReltns, relationsRef?.current ]);

	const isPublicSelected = useMemo(() =>
	{
		const isAllRelationsSelected = updateReltns?.filter((r) => typeof r !== 'string')?.length === relationsRef?.current?.length;

		return isAllRelationsSelected && isInternalEmployeesSelected;
	}, [ updateReltns, relationsRef?.current, isInternalEmployeesSelected ]);

	return (
		<Grid container spacing={0}>
			<Grid item xs={12}>
				<Stack direction={'column'}>
					<FormControlLabel
						sx={{
							'& .MuiFormControlLabel-label' : {
								fontSize   : 'var(--pixel16)',
								fontWeight : 500,
								color      : 'var(--txtColorBlackL)'
							}
						}}
						label={language.public}
						control={
							<Checkbox
								checked={isPublicSelected}
								indeterminate={updateReltns?.length > 0 && !isPublicSelected}
								onChange={() => handleReltns('All')}
							/>
						}
					/>
					<Typography variant='body2' fontWeight='var(--font500)' color={'var(--txtColorBlackL)'}>
						{language.pubslishtext}
					</Typography>
				</Stack>
			</Grid>
			{relationsRef?.current?.find((reltn) => reltn?.relation === 'company internal employees') && (
				<Grid item xs={12} pl='var(--pixel8)' pt='var(--pixel8)'>
					<FormControlLabel
						sx={{
							'& .MuiFormControlLabel-label' : {
								fontSize   : 'var(--pixel14)',
								fontWeight : 500,
								color      : '#8F8F8F'
							}
						}}
						label='company internal employees'
						control={
							<Checkbox
								checked={isInternalEmployeesSelected}
								indeterminate={updateReltns?.find((r) => typeof r === 'string')}
								onChange={() => handleReltns(relationsRef?.current?.find((r) => r?.relation === 'company internal employees'))}
							/>
						}
					/>
					<Grid item xs={12} pl='var(--pixel16)' pt='var(--pixel8)'>
						<Stack direction='row' alignItems='center' spacing={1} sx={{ display: 'flex', flexWrap: 'wrap' }}>
							{isLoading
								? (
									<Box display='flex' alignItems='center'>
										<CircularProgress size={16} />
										<Typography ml={1} variant='caption' color='textSecondary'>
											Loading departments...
										</Typography>
									</Box>
								)
								: (
									<>
										<Chip
											size='small'
											label='All'
											variant={isInternalEmployeesSelected ? 'filled' : 'outlined'}
											sx={{
												backgroundColor : isInternalEmployeesSelected ? '#24A4C4' : 'transparent',
												color           : isInternalEmployeesSelected ? 'white' : 'black',
												borderColor     : isInternalEmployeesSelected ? 'transparent' : '#666666',
												'&:hover'       : { backgroundColor: isInternalEmployeesSelected ? '#1b8ba7' : '#e0e0e0' },
												margin          : '4px !important',
												paddingBottom   : '1px',
												borderRadius    : '10px'
											}}
											onClick={() => handleReltns(relationsRef?.current?.find((r) => r?.relation === 'company internal employees'))}
										/>
										{departments.map((dept) => (
											<Chip
												size='small'
												key={dept._id}
												label={dept.name}
												variant={isDepartmentSelected(dept.name) ? 'filled' : 'outlined'}
												sx={{
													backgroundColor : isDepartmentSelected(dept.name) ? '#24A4C4' : 'transparent',
													color           : isDepartmentSelected(dept.name) ? 'white' : 'black',
													borderColor     : isDepartmentSelected(dept.name) ? 'transparent' : '#666666',
													'&:hover'       : { backgroundColor: isDepartmentSelected(dept.name) ? '#1b8ba7' : '#e0e0e0' },
													margin          : '4px !important',
													paddingBottom   : '1px',
													borderRadius    : '10px'
												}}
												onClick={() => handleDepartmentClick(dept.name)}
											/>
										))}
									</>
								)}
						</Stack>
					</Grid>
				</Grid>
			)}

			{/* Other Relations Section */}
			{createFeedAs !== 'self' && <Grid item container pl='var(--pixel8)' pt='var(--pixel8)'>
				{relationsRef?.current
					? relationsRef?.current
						?.filter((reltn) => reltn?.relation !== 'company internal employees')
						?.map((reltn) =>
							(
								<Grid item xs={12} sm={6} md={6} lg={6} key={reltn?.relationId}>
									<FormControlLabel
										sx={{
											'& .MuiFormControlLabel-label' : {
												fontSize   : 'var(--pixel14)',
												fontWeight : 500,
												color      : '#8F8F8F'
											}
										}}
										label={reltn?.relation}
										control={
											<Checkbox
												checked={updateReltns?.some((dataD) => dataD?.relationId === reltn?.relationId)}
												onChange={() => handleReltns(reltn)}
											/>
										}
									/>
								</Grid>
							))
					: ''}

			</Grid>}
		</Grid>
	);
};

export default SelectRelations;
